import { configureStore } from '@reduxjs/toolkit'

import headerTitleReducer from './headerTitleSlice'
import holidayReducer from './holidaySlice'
import snackbarReducer from './snackbarSlice'

export const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    headerTitle: headerTitleReducer,
    holiday: holidayReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
